module.exports = __webpack_public_path__ + "img/pic_ordermiss.1775439203884.png";